import React from 'react'
import { Link } from 'chemistry'

export const CollapsibleListButton = props => {
  return <Link as='button' d='flex' {...props} />
}
